<script setup>
import { computed, inject } from 'vue';
import AchievementTable from '@/components/result/AchievementTable.vue'; 

// 부모에서 주입받은 데이터
const classData = inject('classData');
const loading = inject('loading');

const region = "seoul";

// 학년 표시용 텍스트 (고등학교 1학년 기준)
const levelYear = computed(() => {
    if (!classData.value) return "고1학년";
    
    const schulType = classData.value.schul_type || 'H';
    const gradeCode = classData.value.grade_code || '1';
    
    if (schulType === 'E') {
        return `${gradeCode}학년`;
    } else if (schulType === 'M') {
        return `중${gradeCode}학년`;
    } else if (schulType === 'H') {
        return `고${gradeCode}학년`;
    }
    return `${gradeCode}학년`;
});

// AchievementTable에 전달할 학년 코드
const shortLevelYear = computed(() => {
    if (!classData.value) return "고1";
    
    const schulType = classData.value.schul_type || 'H';
    const gradeCode = classData.value.grade_code || '1';
    
    if (schulType === 'E') {
        return `초${gradeCode}`;
    } else if (schulType === 'M') {
        return `중${gradeCode}`;
    } else if (schulType === 'H') {
        return `고${gradeCode}`;
    }
    return `고${gradeCode}`;
});
</script>

<template>
    <div class="slide-inner ">
        <div class="content">
            <AchievementTable type="literacy" :region="region" :levelYear="shortLevelYear" :isStudent="false" class="pt-10 pb-10" />
            <AchievementTable type="numeracy" :region="region" :levelYear="shortLevelYear" :isStudent="false" />
        </div>
        <p class="caution pt-4">각 성취 수준에 있는 기술은 해당 수준에 있는 학생이 ‘확률적’으로 수행할 것으로 기대되는 내용을 제시한 것이며, 각 학생이 실제로 성취 수준에 있는 내용을 수행했다는 것을 의미하지는 않습니다.</p>
    </div>
</template>
